import { render, staticRenderFns } from "./NotifySpan.vue?vue&type=template&id=b6da76c8&scoped=true&"
import script from "./NotifySpan.vue?vue&type=script&lang=js&"
export * from "./NotifySpan.vue?vue&type=script&lang=js&"
import style0 from "./NotifySpan.vue?vue&type=style&index=0&id=b6da76c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6da76c8",
  null
  
)

export default component.exports